import React from 'react'
import { assets } from '../../assets/assests'
import './Hero.css'

export const Hero = () => {
 
  return (
    <section className='hero' id='Hero'>
      <div className="hero-content" data-aos="fade-up">
        <img 
        src={assets.ragulnew2_icon}
        alt="Profile"
        className='hero-img' 
        data-aos="zoom-in"
        data-aos-delay="200" />
        <h1 data-aos="fade-down" data-aos-delay="400">
          Hi, I'm <span className='highlight'>Ragul</span>
        </h1>
        <h2 data-aos="fade-right" data-aos-delay="600">
          Frontend Developer & <span className='span-line'>React expert</span></h2>
        <p className="hero-description" data-aos="fade-up" data-aos-delay="800">
            Crafting sleek and dynamic websites with passion and precision.<br />
            Explore my <span className="highlight-box">projects</span>, view my <span className="highlight-box">resume</span>,<br />
            or reach out at ragulm550@gmail.com.
        </p>
        <div className="resume-button-wrapper">
        <a href="/ragul-resume.pdf" download className="resume-button">
          Download Resume
        </a>
        </div>
        

   

        </div>
    </section>
  )
}

